import { ObjectSchema } from 'yup';
import * as R from 'ramda';
import { FORM_ERROR, setIn } from 'final-form';

declare global {
    interface Window {
        INBOX_DEBUG: boolean;
    }
}

export default function createValidationHandler(
    schemaOrFunctionToCreateSchema: ((values: object) => ObjectSchema<{}>) | ObjectSchema<{}> | undefined,
    validate?: (values: object) => string | undefined,
    context?: object
) {
    if (!schemaOrFunctionToCreateSchema) {
        return undefined;
    }

    return R.memoizeWith(JSON.stringify, async (values: object) => {
        let output: any = {};

        if (validate) {
            output[FORM_ERROR] = validate(values);
        }

        const schema =
            typeof schemaOrFunctionToCreateSchema === 'function'
                ? schemaOrFunctionToCreateSchema(values)
                : schemaOrFunctionToCreateSchema;

        if (schema) {
            try {
                await schema.validate(values, { abortEarly: false, strict: true, context });
            } catch (error) {
                output = {
                    ...output,
                    ...('inner' in error
                        ? error.inner.reduce((formError, innerError) => {
                              return setIn(formError, innerError.path, innerError.message);
                          }, {})
                        : error),
                };
            }
        }

        if (window.top?.INBOX_DEBUG) {
            console.error(output);
        }

        return output;
    });
}
